import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.capitalize.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("input", this.capitalize.bind(this))
  }

  capitalize() {
    const input = this.element
    const pos = input.selectionStart
    const val = input.value
    let result = ""
    let capitalizeNext = true

    for (let i = 0; i < val.length; i++) {
      const ch = val[i]
      if (capitalizeNext && /[a-zA-Z]/.test(ch)) {
        result += ch.toUpperCase()
        capitalizeNext = false
      } else {
        result += ch
        if (ch === " " || ch === "-" || ch === "'") {
          capitalizeNext = true
        }
      }
    }

    if (result !== val) {
      input.value = result
      input.setSelectionRange(pos, pos)
    }
  }
}
